export default __webpack_public_path__ + "static/media/cat.f12b4eef.png";